'use strict';

/* global google */

var $body = $('body');
const domesticCountry = 'IN';
var validatePinCode = require('../validatePinCode');
var addressComplete = require('../addressComplete');

/**
 * @param {element} input - inputTag
 * @param {element} label - respective label
 */
function blankField(input) {
    input.val('');
    input.removeClass('has-value');
}

$('body').on('shown.bs.modal', '#addAddressModal, #deliveryCheckModal', function () {
    var country = $('#addressCountryDropdown').attr('country-code') || 'IN';
    addressComplete.initAutocomplete(country);
});

$(window).on('load', function () {
    var country = $('#addressCountryDropdown').attr('country-code') || 'IN';
    addressComplete.initAutocomplete(country);
});
/**
 * Validates a pincode by checking if it's invalid based on specific criteria.
 *
 * @param {string} pincode - The pincode to validate.
 * @returns {boolean} Returns `true` if the pincode is invalid (i.e., not a 6-digit number
 * or a "fancy" pincode like all digits being the same), otherwise `false`.
 */
function isInvalidPincode(pincode) {
    var validPinRegex = /^\d{6}$/;
    var fancyPinRegex = /^(\d)\1{5}$/;
    return !validPinRegex.test(pincode) || fancyPinRegex.test(pincode);
}
module.exports = {
    isInvalidPincode: isInvalidPincode,
    stateAndCity: function () {
        var ajaxFlag = true;
        /**
         * Handles invalid pincode by clearing city and state fields
         * and displaying an error message.
         */
        function handleInvalidPincode() {
            $('#city').val('');
            $('#states').val('');
            var $pincode = $('#postalCode').val();
            const $errorMsgForInputPincode = $('#postalCode').closest('.form-group').find('.invalid-feedback');
            if (isInvalidPincode($pincode)) {
                $errorMsgForInputPincode.removeClass('d-none').addClass('d-block');
            } else {
                $errorMsgForInputPincode.addClass('d-none').removeClass('d-block');
            }
        }

        $body.on('keyup change', '#postalCode', async function (e) {
            var country = $('#addressCountryDropdown').attr('country-code') || 'IN';
            var form = $(this).closest('form');
            var pincode = $(this).val();
            var defaultMinLength = 6;
            var defaultMaxLength = 6;
            var minLength = $(this).attr('minlength') ? parseInt($(this).attr('minlength'), 10) : defaultMinLength;
            var maxLength = $(this).attr('maxlength') ? parseInt($(this).attr('maxlength'), 10) : defaultMaxLength;
            var state = $('#state', form);
            var city = $('#city', form);
            var changeEvent = e.type === 'change';
            // Setup ajaxFlag
            if (pincode.length < maxLength || changeEvent) {
                ajaxFlag = true;
            }
            var $inputPincodeField = $('#postalCode');
            var $errorMsgForInputPincode = $inputPincodeField.closest('.form-group').find('.invalid-feedback');
            // custom length
            if (country === domesticCountry && pincode.length >= minLength && pincode.length <= maxLength && ajaxFlag) {
                $body.spinner().start();
                var originalPincode = $('#postalCode').val();
                var countryCode = 'IN';
                var Geocoder = new google.maps.Geocoder();
                try {
                    var addressResult = await Geocoder.geocode({
                        address: originalPincode,
                        componentRestrictions: {
                            country: countryCode, postalCode: originalPincode
                        }
                    });
                    var isValidPincode = validatePinCode.validatePincodeFromGeocodeResult(addressResult);
                    if (isValidPincode) {
                        $('#state').parent().removeClass('error-class').find('.error-message')
                            .addClass('d-none');
                        $('#city').parent().removeClass('error-class').find('.error-message')
                            .addClass('d-none');
                        $errorMsgForInputPincode.text('').hide();
                        $inputPincodeField.addClass('valid-pincode');
                        $inputPincodeField.closest('.delivery-check').find('.check-link').trigger('click');
                    } else {
                        handleInvalidPincode();
                    }
                } catch (error) {
                    handleInvalidPincode();
                }
                // Setup ajaxFlag
                if (pincode.length >= maxLength) {
                    ajaxFlag = false;
                }
                $body.spinner().stop();
            } else if (country === domesticCountry && ajaxFlag) {
                blankField(state);
                blankField(city);
            }
        });
    }
};
